import Button from "components/Button";
import React from "react";
import { dateFormat } from "utils/dayPickerDataFormatting";
import classes from "./BookingWidgetBar.module.css";
import { useBottomBarSize } from "../../../../hooks/useBottomBarSize";
import { formatInteger } from "utils/formatNumber";
import { formatNumber } from "utils/convertCents";
import Typography from "components/Typography";
import classnames from "classnames";

export const BookingWidgetBar = (props) => {
  const {
    minimumDuration,
    priceWidget,
    totalWidget,
    discountWidget,
    date,
    setIsShowModalBookingWidget,
    newPrice,
    price_per_night,
    nights,
    old_price,
    setShowPriceTable,
    priceTableLoading
  } = props;

  const departureDate = dateFormat(date.departure);
  const returnDate = dateFormat(date.return);

  const barRef = useBottomBarSize();
  const newTotalWidget = totalWidget && formatInteger(totalWidget);
  const newPriceWidget = priceWidget && formatInteger(priceWidget);

  return (
    <div className={`${classes.bookingWidgetBar}`} ref={barRef}>
      <div className={`${classes.bookingWidgetBarLeftColumn}`}>
        <div className="dn-m">
          <div className={classes.priceHeader}>
            <div className={classes.priceNewPriceContainer} onClick={() => setShowPriceTable(true)}>
              <Typography
                variant="subtitle"
                size="m"
                className={classnames('underline', classes.priceNewPrice, discountWidget && classes.priceNewPriceWithDiscount)}
              >
                ${formatNumber(newPrice)} total
              </Typography>
            </div>

            <Typography
              variant="body"
              size="s"
              className={classnames(classes.priceNights, discountWidget && classes.priceNightsWithDiscount)}
            >
              for {nights} nights
            </Typography>
          </div>

          {discountWidget ? (
            <div className={classes.priceFooter}>
              <Typography
                variant="subtitle"
                size="s"
                className={classes.priceOldPrice}
              >
                ${formatNumber(old_price)}
              </Typography>
              {discountWidget && (
                <div className={`${classes.bookingWidgetBarDiscount}`}>
                  -{discountWidget}%
                </div>
              )}
            </div>
          ): null}
        </div>
        <div className="dn db-m">
          <div className={classes.priceHeader}>
            {discountWidget ? (
              <Typography
                variant="subtitle"
                size="s"
                className={classnames(classes.priceOldPrice, classes.priceMiddleOldPrice)}
              >
                ${formatNumber(old_price)}
              </Typography>
            ): null}
            <div className={classnames(classes.priceNewPriceContainer, classes.priceMiddleNewPriceContainer)} onClick={() => setShowPriceTable(true)}>
              <Typography
                variant="subtitle"
                size="m"
                className={classnames('underline', classes.priceNewPrice)}
              >
                ${formatNumber(newPrice)} total
              </Typography>
            </div>
            {discountWidget && (
              <div className={`${classes.bookingWidgetBarDiscount}`}>
                -{discountWidget}%
              </div>
            )}
          </div>
          <div>
            <Typography
              variant="body"
              size="s"
              className={classes.priceNights}
            >
              for {nights} nights
            </Typography>
          </div>
          <div>
            <Typography
              variant="caption"
              className={classes.pricePerNights}
            >
              ${formatNumber(price_per_night)} nightly rate
            </Typography>
          </div>
        </div>
      </div>

      <div className={`${classes.bookingWidgetBarRightColumn}`}>
        <div className={`${classes.bookingWidgetBarDateContainer}`}>
          <h3 className={`${classes.bookingWidgetBarDateTitle}`}>
            Departure/Return
          </h3>
          <div className={`${classes.bookingWidgetBarDateInfo}`}>
            {departureDate} - {returnDate}
          </div>
        </div>

        <div className={`${classes.bookingWidgetBarButtonContainer}`}>
          <Button
            onClick={() => {
              setIsShowModalBookingWidget(true);
            }}
            className={`${classes.bookingWidgetBarButton}`}
            label="Reserve RV"
          />
        </div>
      </div>
    </div>
  );
};
